import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppConfigService } from '../services/app-config.service';

export const loginGuard: CanActivateFn = () => {
    const appConfig = inject(AppConfigService);
    const router = inject(Router);
    if (!appConfig.loginObrigatorio()) {
        router.navigate(['/home']);
        return false;
    }
    return true;
};
